<template>
  <div>
    <!-- Error Messages -->
    <app-errors></app-errors>

    <!-- Loading Progress Icon -->
    <app-loader></app-loader>

    <v-content>
      <v-card>
        <v-app-bar dark flat fixed app :color="headerColor" tile>
          
           <v-btn 
            v-if="!$route.meta.hideFooterHomeNav" 
            icon 
            @click.prevent="goHome"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-toolbar-title>{{ winTitle }}</v-toolbar-title>
        </v-app-bar>

        <v-card-text style="background-color: #E7E7E7">
          <v-form ref="form">
            <v-container>
              <!-- Error details during upload -->
              <v-row v-if="editedItem.error_msg">
                <v-col cols="12" sm="12">
                  <h2 class="primary--text">{{ $t("label.error_details") }}</h2>
                </v-col>
              </v-row>

              <div class="error--text">
                {{ editedItem.error_msg }}
              </div>

              <!-- Main Details -->
              <!-- <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                      >
                      </v-col>
                    </v-row> -->

              <!-- list of data -->
              <v-list three-line color="#E7E7E7">
                <div class="list-wrapper">
                  <h1 class="list-header">
                    Task {{ taskid }}
                  </h1>

                  <template v-for="(item, index) in filteredItems">
                    <v-list-item
                      class="list-item"
                      v-touch="{
                        left: () => swipe(item, 'Left'),
                        right: () => swipe(item, 'Right'),
                      }"
                      ripple
                      :key="item.TaskMaterialId"
                      :id="item.TaskMaterialId"
                      @click.prevent=""
                    >
                      <v-list-item-content class="list-content">
                        <v-list-item-subtitle class="line2"
                          >{{ item.quantity }} {{ item.uom }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="line1">{{
                          item.description
                        }}</v-list-item-subtitle>
                        <v-list-item-subtitle class="line3">{{
                          item.partId
                        }}</v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action @click.stop> </v-list-item-action>
                    </v-list-item>

                    <v-divider
                      v-if="index + 1 > items.length"
                      :key="index * -1"
                    ></v-divider>
                  </template>
                </div>
              </v-list>
              <v-card-actions class="button-wrap">
                <v-btn @click.native="goBack" class="bom-button-cancel"
                  >{{ $t("label.cancel") }}
                </v-btn>

                <v-btn @click.native="save(0)" class="bom-button-reject"
                  >{{ $t("label.reject") }}
                </v-btn>

                <v-btn @click.native="save(1)" class="bom-button-accept"
                  >{{ $t("label.accept") }}
                </v-btn>
              </v-card-actions>

              <!--  
                         only visible if  exclude_section == 0 -->
              <template v-if="exclude_section == 0"> </template>
            </v-container>
          </v-form>
        </v-card-text>
      </v-card>
    </v-content>

    <!-- Footer -->
    <app-footer></app-footer>
  </div>
</template>

<script>
import Vue from "vue";
import moment from "moment";

export default {
  props: {
    taskid: {
      type: [Number],
      required: true,
    },
  },

  data() {
    return {
      moment: moment,

      pagename: "BOM",
      winTitle: "",

      editedItem: {},

      items: [],

      validationInProgress: 0,

      exclude_section: false,
    };
  },

  computed: {
    dark() {
      if (localStorage.getItem("darkTheme") === "true") return true;
      return false;
    },

    primaryColor() {
      return localStorage.getItem("primaryColor");
    },

    headerColor() {
      if (this.dark) return "#212121";
      return "#4B4B4B";
    },

    currentLocale() {
      return localStorage.getItem("currentLocale");
    },

    currentRTL() {
      const rtl = localStorage.getItem("currentRTL");
      if (rtl === "true") return true;
      return false;
    },

    filteredItems() {
      return this.items;
    },
  },

  methods: {
    goHome() {
      // Clear all list position info
      // Go to home page
      this.$router.replace({ name: "Tasks" }).catch((err) => {});
    },

    gotoTop() {
      this.$vuetify.goTo(0, { duration: 0, offset: 0 });
    },

    goBack() {
      // Clear any list position info
      this.$store.dispatch("deleteListPosition", this.pagename);

      // Go Back a page
      this.$router.go(-1);
    },

    async save(materialChecked) {
      // Update TaskMaterialChecked flag on Task record
      let url = "/rpc/UpdateTaskMaterialChecked";
      let payload = { TaskId: this.taskid, materialChecked: materialChecked };

      this.$store
        .dispatch("apiPut", { url, payload })
        .then((response) => {
          // not in use at the moment
          this.editedItem = response.data;
          this.goBack();
        })
        .catch(() => {
          // console.log(error)
        });
    },
  },

  created() {
    let url = "";
    let payload = {};

    this.gotoTop();

    // Set Page Title
    this.winTitle = this.$i18n.t("title." + this.pagename);

    // Retrieve Main Data
    url = "/query/TaskMaterial";
    payload = { taskid: this.taskid };

    this.$store
      .dispatch("apiPost", { url, payload })
      .then((response) => {
        this.items = response.data;
      })
      .catch(() => {
        // console.log(error)
      });
  },
};
</script>
